import { Component } from '@angular/core';
import { NavbarComponent } from "../../../../partials/navbar/navbar.component";
import { FooterComponent } from "../../../../partials/footer/footer.component";
import { LanguageService } from '../../../../services/language.service';

@Component({
  selector: 'app-how-to-read-tires',
  standalone: true,
  imports: [NavbarComponent, FooterComponent],
  templateUrl: './how-to-read-tires.component.html',
  styleUrl: './how-to-read-tires.component.css'
})
export class HowToReadTiresComponent {
  texts:any;
  back: any;

  constructor(private langServ: LanguageService) {
    this.texts = this.langServ.getWebisteTexts().posts.how_to_read_tires;
    this.back = this.langServ.getWebisteTexts().posts.volver_text;
  }
}
